import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Container from "@ui/container";

const LoadingSkeletonScreen = () => {
    return (
        <Container className="my-4">
            <Skeleton count={1} height={50} />
            <div className="mt-4"></div>
            <Skeleton count={2} height={30} />
            <div className="mt-4"></div>
            <Skeleton count={1} height={100} width={100} />
            <Skeleton count={3} height={30} />
            <div className="mt-4"></div>
            <Skeleton count={1} height={200} />
            <div className="mt-4"></div>
            <Skeleton count={1} height={30} />
            <Skeleton count={1} height={30} />
            <div className="mt-4"></div>
            <Skeleton count={1} height={200} />
        </Container>
    );
};

export default LoadingSkeletonScreen;
